import {
  FETCH_ALIASES,
  FETCH_ALIASES_SUCCESS,
  FETCH_ALIASES_FAILURE,
  FETCH_ALIAS_FAILURE,
  ADD_ALIAS,
  ADD_ALIAS_SUCCESS,
  ADD_ALIAS_FAILURE,
  UPDATE_ALIAS,
  UPDATE_ALIAS_SUCCESS,
  UPDATE_ALIAS_FAILURE,
  REMOVE_ALIAS,
  REMOVE_ALIAS_SUCCESS,
  REMOVE_ALIAS_FAILURE,
} from './types'

export const fetchAliases = (accessToken) => ({
  type: FETCH_ALIASES,
  payload: { accessToken },
})

export const fetchAliasesSuccess = (payload) => ({
  type: FETCH_ALIASES_SUCCESS,
  payload,
})

export const fetchAliasesFailure = (payload) => ({
  type: FETCH_ALIASES_FAILURE,
  payload,
})

export const fetchAliasFailure = (payload) => ({
  type: FETCH_ALIAS_FAILURE,
  payload,
})

export const addAlias = (aliasName, indexName, accessToken) => ({
  type: ADD_ALIAS,
  payload: { aliasName, indexName, accessToken },
})

export const addAliasSuccess = (payload) => ({
  type: ADD_ALIAS_SUCCESS,
  payload,
})

export const addAliasFailure = (payload) => ({
  type: ADD_ALIAS_FAILURE,
  payload,
})

export const updateAlias = (aliasName, indexName, accessToken) => ({
  type: UPDATE_ALIAS,
  payload: { aliasName, indexName, accessToken },
})

export const updateAliasSuccess = (payload) => ({
  type: UPDATE_ALIAS_SUCCESS,
  payload,
})

export const updateAliasFailure = (payload) => ({
  type: UPDATE_ALIAS_FAILURE,
  payload,
})

export const removeAlias = (aliasName, indexName, accessToken) => ({
  type: REMOVE_ALIAS,
  payload: { aliasName, indexName, accessToken },
})

export const removeAliasSuccess = (payload) => ({
  type: REMOVE_ALIAS_SUCCESS,
  payload,
})

export const removeAliasFailure = (payload) => ({
  type: REMOVE_ALIAS_FAILURE,
  payload,
})
